import React, { useEffect, useState } from 'react';
import { Box } from 'glints-aries';
import Markdown from 'react-markdown';
import { useSelector } from 'react-redux';

import { useConfig } from 'src/common/hooks';
import { MetadataRenderer } from 'src/components/MetaDescription/MetadataRenderer';
import { getCountryWithSGFallback } from 'src/modules/ClientConfig/Selectors';
import * as S from 'src/modules/Terms/TermsPage.sc';

const meta = {
  title: 'Standard Terms For Service',
};

export const StandardTermsForServices = () => {
  const [markdownTerms, setMarkdownTerms] = useState();
  const { LANG } = useConfig();
  const COUNTRY = useSelector(getCountryWithSGFallback);

  useEffect(() => {
    import(`./standardTermsForServices/${COUNTRY}/${LANG.toLowerCase()}.md`)
      .then((module) => {
        setMarkdownTerms(module.default);
      })
      .catch(() => {
        console.error(
          `Terms of service not found for ${COUNTRY} for language ${LANG.toLowerCase()}`
        );
      });
  }, [LANG, COUNTRY]);

  return (
    <S.TermsPageContainer>
      <Box pt={24}>
        <MetadataRenderer
          {...meta}
          glintsTrackingName="standard_terms_for_services"
        />
        <S.MarkdownGlintsContainer>
          <Markdown>{markdownTerms}</Markdown>
        </S.MarkdownGlintsContainer>
      </Box>
    </S.TermsPageContainer>
  );
};
